module.exports = __webpack_public_path__ + "media/assets/images/task_move-149de91122532ec78e8d5d17ddef356f.png";